import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

import {NutshellFieldPicker} from '../../../../../core/nutshell-fields';
import type {FormSchemaProperty} from '../../../../../core/nutshell-fields/types';
import {useGetSessionUser} from '../../../../../core/use-get-session-user';
import type {FormFieldRowForDuplicateHelpers, SelectFieldInput} from '../../../../types';

import {isDisabled, getDisabledText, getFilteredFields} from './helpers';

import styles from './other-fields.module.css';

type Props = {
    fields: FormFieldRowForDuplicateHelpers[];
    onSelectInputField: (arg1: SelectFieldInput) => void;
    nutshellFieldsSearchValue: string;
    excludeFirstLastNames?: boolean;
};

export function NutshellFields(props: Props) {
    const {user} = useGetSessionUser();
    const canManageCustomFields = user && user.permissions.canAccessSetup;

    return (
        <div
            className={canManageCustomFields ? styles['container--with-footer'] : styles.container}
        >
            <NutshellFieldPicker
                onSelectField={(field: FormSchemaProperty) =>
                    props.onSelectInputField({
                        fieldKey: field.name,
                        displayType: field.displayType,
                        entityType: field.entityType,
                    })
                }
                customFilterFunction={(schemaFields: FormSchemaProperty[]) =>
                    getFilteredFields({
                        schemaFields,
                        fields: props.fields,
                        view: 'nutshell-fields',
                        excludeFirstLastNames: props.excludeFirstLastNames,
                    })
                }
                getIsItemDisabled={(field: FormSchemaProperty) => isDisabled(props.fields, field)}
                getDisabledText={(field: FormSchemaProperty) =>
                    getDisabledText(props.fields, field.name, field.entityType)
                }
                searchValue={props.nutshellFieldsSearchValue}
            />
            {canManageCustomFields && (
                <div className={styles.footer}>
                    <Link
                        // @ts-expect-error
                        as={RouterLink}
                        size='small'
                        to={
                            NutClientConfig.hasPerPipelineCustomFields
                                ? `/setup/custom-field`
                                : '/setup/custom-field-old'
                        }
                        variant='primary'
                        newTab={true}
                    >
                        Manage custom fields
                    </Link>
                </div>
            )}
        </div>
    );
}
